/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { NDCDetailsTextFieldComponent } from '../../../NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { ArrowComponent } from '../../../NDC/component/NDCDetails/NDCDetailsPagiantion';
import {
  setEditedRows,
  setSelectedClaimIndex,
  resetEditedRows,
  getClaimTableInfo,
} from '../../store/action';

const SelectedClaimHeader = ({
  data,
  pageClaimData,
  setErrorMessage,
  currentIndex,
  claimSelectByFilter,
 successMessages,
  setSuccessMessages
}) => {
  const dispatch = useDispatch();
  const [paginationIndex, setPaginationIndex] = useState(currentIndex + 1);
  const [openUnsavedModal, setOpenUnsavedModal] = useState(false);
  const [nextPageIndex, setNextPageIndex] = useState(null);
  const [beforePageIndex, setBeforePageIndex] = useState(null);

  const editedData = useSelector(
    (state) => state.sharedState.NumberOfUnits.editedData
  );
  const [headerInfo, setHeaderInfo] = useState({
    drugName: '',
    ndc: '',
    paidQtr: '',
  });
  useEffect(() => {
    if (
      pageClaimData[0]?.claimResultVOList?.length > 0 &&
      pageClaimData[0]?.claimResultVOList[0]
    ) {
      setHeaderInfo({
        drugName:
          pageClaimData[0].claimResultVOList?.length > 0 &&
          pageClaimData[0].claimResultVOList[0] &&
          pageClaimData[0].claimResultVOList[0].drugVO.drugName,
        ndc:
          pageClaimData[0].claimResultVOList?.length > 0 &&
          pageClaimData[0].claimResultVOList[0] &&
          pageClaimData[0].claimResultVOList[0].drugVO.ndc,
        paidQtr: getFormattedQuater(
          pageClaimData[0].claimResultVOList[0].paidQtr
        ),
      });
    }
  }, [pageClaimData]);
  const getFormattedQuater = (quater) => {
    if (quater && quater?.length === 5) {
      return `${quater.substr(4)}Q${quater.substr(0, 4)}`;
    }
    return quater;
  };

  useEffect(() => {
    setPaginationIndex(currentIndex + 1);
  }, [currentIndex]);

  const setPageIndexInRedux = (page) => {
    dispatch(setErrorMessage(null));
    dispatch(setSelectedClaimIndex(page));
    dispatch(getClaimTableInfo(true));
    setEditedData([]);
  };

  const setEditedData = (value) => dispatch(setEditedRows(value));

  const handleNextAndPrevClick = (isNext = true) => {
    if(successMessages){
      setSuccessMessages([])
    }
    const index = currentIndex + 1 + (isNext ? 1 : -1);
    if (parseInt(index) < 1 || parseInt(index) > data.length) {
      // Handle out-of-bounds case
    } else if (editedData?.length > 0) {
      setNextPageIndex(parseInt(index));
      setOpenUnsavedModal(true);
    } else {
      setPageIndexInRedux(parseInt(index));
      dispatch(resetEditedRows()); // Reset editedData when navigating to the next page
    }
  };

  const showErrorPopup = (message) => {
    dispatch(setErrorMessage(message));
    setPaginationIndex(currentIndex + 1);
  };

  return (
    <div className="col-sm-12">
      <SaveCancelPopup
        open={openUnsavedModal}
        title="Cancel"
        onConfim={() => {
          setOpenUnsavedModal(false);
          setPageIndexInRedux(nextPageIndex);
          if (beforePageIndex !== null) {
            setBeforePageIndex(null);
          }
        }}
        onCancel={() => {
          setOpenUnsavedModal(false);
          if (beforePageIndex !== null) {
            setPaginationIndex(beforePageIndex);
            setBeforePageIndex(null);
          }
        }}
      />
      <fieldset className="custom-fieldset">
        <div className="col-12 my-2 d-flex align-items-center justify-content-end">
          <ArrowComponent
            className="mr-2"
            component={
              <i className="fa fa-light fa-caret-left" aria-hidden="true" />
            }
            onClick={() => {   
              handleNextAndPrevClick(false)}}
          />
          <span id="navigation">Page</span>

          <div className="mui-custom-form with-select pagination-text-field">
            <TextField
              type="string"
              value={paginationIndex}
              style={{ maxWidth: '55px' }}
              inputProps={{
                'aria-labelledby': 'navigation',
              }}
              onChange={(e) => {
                if(successMessages){
                  setSuccessMessages([])
                }
                dispatch(setErrorMessage(null));
                if (/^[0-9]+$/g.test(e.target.value)) {
                  if (parseInt(e.target.value) === 0) {
                    dispatch(
                      setErrorMessage(['Please input a positive number.'])
                    );
                    setPaginationIndex(e.target.value);
                  } else if (parseInt(e.target.value) > data.length) {
                    setPaginationIndex(e.target.value);
                    dispatch(
                      setErrorMessage([
                        'Please input a number less than total page.',
                      ])
                    );
                  } else {
                    setBeforePageIndex(paginationIndex);
                    setPaginationIndex(e.target.value);
                    if (editedData?.length > 0) {
                      setNextPageIndex(parseInt(e.target.value));
                      setOpenUnsavedModal(true);
                    } else {
                      setPageIndexInRedux(parseInt(e.target.value));
                    }
                  }
                } else if (e.target.value === '') {
                  dispatch(
                    setErrorMessage(['Please input a numeric value only.'])
                  );
                  setPaginationIndex('');
                }
              }}
            />
          </div>
          <span>{`of ${data?.length}`}</span>
          <ArrowComponent
            className="mt-0 ml-2"
            component={
              <i className="fa fa-light fa-caret-right" aria-hidden="true" />
            }
            onClick={() => handleNextAndPrevClick()}
          />
        </div>
        <div className="p-0 mt-2 row">
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Paid Qtr"
              value={
                headerInfo.paidQtr
                // data && data[currentIndex] && claimSelectByFilter.paidQtr
                // data[currentIndex].claimResultVOList.length > 0 &&
                // data[currentIndex].claimResultVOList[0].paidQtr &&
                // getFormattedQuater(
                //   data[currentIndex].claimResultVOList[0].paidQtr
                // )
              }
            />
          </div>
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="NDC"
              value={headerInfo.ndc}
            />
          </div>
          <div className="col-4">
            <NDCDetailsTextFieldComponent
              className="ml-0"
              label="Name"
              value={headerInfo?.drugName}
            />
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default SelectedClaimHeader;
